var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.867,
    viewBox: "0 0 16 9.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand-more",
    transform: "translate(0 -0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14.133,0,8,6.133,1.867,0,0,1.867l8,8,8-8Z",
    transform: "translate(0 0.6)",
    fill: "rgba(0,0,0,0.54)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.354af4de8280e9a11e52f4946b307dc5.svg";
export { ForwardRef as ReactComponent };